export type TrackImplProps<Stage = string> = {
	newStage: Stage;
	prevStage: Stage;
	absoluteChangeTs: number;
	relativeChangeTs: number;
};
export type TrackImpl<Stage> = (props: TrackImplProps<Stage>) => void;
type StageType<Stages extends Record<string, string>> = keyof Stages;
export interface IStateChageTracker<Stages extends Record<string, any>> {
	stages: Stages;
	currendStage: StageType<Stages>;
	trackImpl: TrackImpl<keyof Stages>;
	changedAt: number;
	constructedAt: number;
	trackStateChange(props: { newState: StageType<Stages> }): void;
}
export class StateChageTracker<Stages extends Record<string, any>>
	implements IStateChageTracker<Stages>
{
	stages: Stages;
	currendStage: StageType<Stages>;
	trackImpl: TrackImpl<StageType<Stages>>;
	changedAt: number;
	constructedAt: number;
	constructor(props: {
		stages: Stages;
		initStage: StageType<Stages>;
		trackImpl: TrackImpl<StageType<Stages>>;
	}) {
		this.stages = props.stages;
		this.currendStage = props.initStage;
		this.trackImpl = props.trackImpl;
		this.changedAt = Date.now();
		this.constructedAt = Date.now();
	}
	trackStateChange(props: { newState: StageType<Stages> }) {
		const changeTs = Date.now();
		try {
			this.trackImpl({
				newStage: props.newState,
				prevStage: this.currendStage,
				relativeChangeTs: changeTs - this.changedAt,
				absoluteChangeTs: changeTs - this.constructedAt
			});
		} catch (_e) {}
		this.currendStage = props.newState;
		this.changedAt = changeTs;
	}
}
